export class MasterParkingDeviceAction {
  ACTION_ID: number = 0;
  DEVICE_ID: number;
  ACTION: string;
  REASON: string;
  DATETIME: string;
  USER_ID: number;
}
